import {Paper, Typography} from '@mui/material';

export interface SessionCompleteScoreProps {
  score: number;
}

export default function SessionCompleteScore({score}: SessionCompleteScoreProps) {
  return (
    <Paper sx={{p: 4, pb: 5, textAlign: 'center', bgcolor: 'primary.main', color: 'white'}}>
      <Typography variant="h2" sx={{fontWeight: 700, mb: 1, color: 'white'}} data-testid="final-score">
        {score}%
      </Typography>
      <Typography variant="h6" sx={{opacity: 0.9, color: 'white'}}>
        Overall Score
      </Typography>
    </Paper>
  );
}
